import { Button } from '../button/Button';
import { withPersonalizedButtonStyle } from '../button/withPersonalizedButtonStyle';
import { styles } from './QuaternaryOnLightButton.styles';

export const QuaternaryOnLightButton = withPersonalizedButtonStyle(Button, styles);
